module.exports = __webpack_public_path__ + "img/Ativo 2.af18152d.png";